import i18next from 'i18next';

// Jazyk aplikácie: predvolená slovenčina. Vlastnú voľbu používateľa si pamätá prehliadač (cookie LANG na 1 rok
// + localStorage) aj účet na serveri (users.language) — Edge s firemnou politikou môže cookies pri zatvorení
// mazať, jazyk z účtu sa potom obnoví po prihlásení. Kód češtiny je v celej aplikácii „cz“ (nie ISO „cs“).
export const SUPPORTED_LANGS = ['cz', 'sk', 'en'];
export const DEFAULT_LANG = 'sk';

const KEY = 'LANG';
const ONE_YEAR_S = 365 * 24 * 60 * 60;

export const normalizeLang = (value) => {
  const tag = String(value || '').trim().toLowerCase().replace('_', '-').split('-')[0];
  const lang = tag === 'cs' ? 'cz' : tag;
  return SUPPORTED_LANGS.includes(lang) ? lang : null;
};

// ISO kód pre <html lang> a hlavičku Accept-Language
export const isoLang = (lang) => (lang === 'cz' ? 'cs' : lang);

const readCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)LANG=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const getSavedLang = () => {
  let lang = normalizeLang(readCookie());
  if (!lang) {
    try { lang = normalizeLang(localStorage.getItem(KEY)); } catch (e) { /* localStorage nedostupný */ }
  }
  return lang;
};

export const initialLang = () => getSavedLang() || DEFAULT_LANG;

export const saveLang = (value) => {
  const lang = normalizeLang(value);
  if (!lang) return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${KEY}=${lang}; path=/; max-age=${ONE_YEAR_S}; SameSite=Lax${secure}`;
  try { localStorage.setItem(KEY, lang); } catch (e) { /* localStorage nedostupný */ }
};

// Stará šifrovaná cookie ULA (do 10/2026) si slovenčinu ukladala aj sama pri prvej návšteve, a voľbu
// z Nastavení len na 1 deň -> ignoruje sa a maže (všetci začínajú na predvolenej češtine).
export const dropLegacyLangCookie = () => {
  const dir = window.location.pathname.replace(/\/[^/]*$/, '') || '/';
  for (const path of new Set(['/', dir])) {
    document.cookie = `ULA=; path=${path}; max-age=0`;
  }
};

export const applyLang = (value) => {
  const lang = normalizeLang(value) || DEFAULT_LANG;
  if (i18next.language !== lang) i18next.changeLanguage(lang);
  document.documentElement.lang = isoLang(lang);
  return lang;
};

// Jazyk z účtu (server) má prednosť — je to voľba používateľa platná v každom prehliadači.
export const applyUserLanguage = (user) => {
  const lang = normalizeLang(user?.language);
  if (lang) {
    saveLang(lang);
    applyLang(lang);
  }
  return lang;
};
